import { IconButton, Tooltip } from '@mui/material'
import { MouseEventHandler, ReactElement, type JSX } from 'react'

interface Props {
  tooltip: string
  icon: ReactElement
  onClick?: MouseEventHandler | undefined
  disabled?: boolean
  visibility?: string
  color?: string
}

const IconButtonWithTooltip = ({
  tooltip,
  onClick,
  icon,
  disabled = false,
  visibility = 'visible',
  color,
  ...otherProps
}: Props): JSX.Element => {
  return (
    <Tooltip title={tooltip} arrow placement="top" disableHoverListener={visibility === 'hidden'}>
      <span>
        <IconButton
          {...otherProps}
          disabled={disabled}
          onClick={onClick}
          sx={{ visibility: visibility || 'visible', color: color || null }}
        >
          {icon}
        </IconButton>
      </span>
    </Tooltip>
  )
}

export default IconButtonWithTooltip
